export const calcularTotalTrabajadores = (values) => {
  return (
    (parseInt(values.cantidadTrabajadoresProduccion) || 0) +
    (parseInt(values.cantidadTrabajadoresEventualesProduccion) || 0) +
    (parseInt(values.cantidadTrabajadoresAdministracion) || 0) +
    (parseInt(values.cantidadTrabajadoresEventualesAdministracion) || 0)
  );
};

// Necesitamos una función aparte, porque si algún campo de trabajadores
// presenta errores, no podemos hacer simplemente parseInt(camposTrabajadores).
// Esto llevaría a errores, como mostrar el Total en -11, o en null.
export const handleGetTotalTrabajadores = (valores, errores) => {
  if (
    errores.cantidadTrabajadoresAdministracion ||
    errores.cantidadTrabajadoresProduccion ||
    errores.cantidadTrabajadoresEventualesAdministracion ||
    errores.cantidadTrabajadoresEventualesProduccion
  ) {
    return "ERROR";
  }

  return calcularTotalTrabajadores(valores);
};